"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PageHeader = _ref => {
  let {
    rightChildren,
    subtitle,
    title
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "page-header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "page-header-title",
    className: "page-header--left"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "page-header-title--left"
  }, title && /*#__PURE__*/_react.default.createElement("h1", {
    className: "title is-1"
  }, title), subtitle && /*#__PURE__*/_react.default.createElement("div", null, subtitle))), rightChildren && /*#__PURE__*/_react.default.createElement("div", {
    className: "page-header--right"
  }, rightChildren));
};
PageHeader.propTypes = {
  rightChildren: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  subtitle: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  title: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
};
PageHeader.defaultProps = {
  rightChildren: null,
  subtitle: '',
  title: ''
};
var _default = exports.default = PageHeader;
//# sourceMappingURL=PageHeader.js.map